/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import React from "react";
import { lazyHydrate } from "~/foundation/Jss";
import { ComponentLoader } from "~/foundation/Components/Loading";
import { Loadable } from "~/foundation/ReactLoadable"
import { default as feature_Media_Card } from "~/feature/Media/Card"
import { default as feature_Media_ScriptAsset } from "~/feature/Media/ScriptAsset"
import { default as feature_Navigation_MainNavigation } from "~/feature/Navigation/MainNavigation"
import { default as feature_Navigation_HygieneNavigation } from "~/feature/Navigation/HygieneNavigation"
import { BreadcrumbNavigation as feature_Navigation_BreadcrumbNavigation } from "~/feature/Navigation/BreadcrumbNavigation"
import { default as project_AramcoCom_Footer } from "~/project/AramcoCom/Footer"

const components = new Map<string, any>();


const feature_Article_ArticleHeader = Loadable({
	loader: () => import(
		/* webpackChunkName: "Article_ArticleHeader" */
		'~/feature/Article/ArticleHeader').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Article_ArticleHeader";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Article_ArticleHeader" {...props} />,
	modules: ['Article_ArticleHeader'],
	moduleId: "Article_ArticleHeader",
});
	

const feature_Article_LatestArticlesCardList = Loadable({
	loader: () => import(
		/* webpackChunkName: "Article_LatestArticlesCardList" */
		'~/feature/Article/LatestArticlesCardList').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Article_LatestArticlesCardList";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Article_LatestArticlesCardList" {...props} />,
	modules: ['Article_LatestArticlesCardList'],
	moduleId: "Article_LatestArticlesCardList",
});
	

const feature_Article_MagazineArticleHeader = Loadable({
	loader: () => import(
		/* webpackChunkName: "Article_MagazineArticleHeader" */
		'~/feature/Article/MagazineArticleHeader').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Article_MagazineArticleHeader";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Article_MagazineArticleHeader" {...props} />,
	modules: ['Article_MagazineArticleHeader'],
	moduleId: "Article_MagazineArticleHeader",
});
	

const feature_Article_AllArticlesCardList = Loadable({
	loader: () => import(
		/* webpackChunkName: "Article_AllArticlesCardList" */
		'~/feature/Article/AllArticlesCardList').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Article_AllArticlesCardList";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Article_AllArticlesCardList" {...props} />,
	modules: ['Article_AllArticlesCardList'],
	moduleId: "Article_AllArticlesCardList",
});
	

const feature_Article_LatestFeaturedArticle = Loadable({
	loader: () => import(
		/* webpackChunkName: "Article_LatestFeaturedArticle" */
		'~/feature/Article/LatestFeaturedArticle').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Article_LatestFeaturedArticle";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Article_LatestFeaturedArticle" {...props} />,
	modules: ['Article_LatestFeaturedArticle'],
	moduleId: "Article_LatestFeaturedArticle",
});
	

const feature_Content_RichText = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_RichText" */
		'~/feature/Content/RichText').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_RichText";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_RichText" {...props} />,
	modules: ['Content_RichText'],
	moduleId: "Content_RichText",
});
	

const feature_Content_Quote = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_Quote" */
		'~/feature/Content/Quote').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_Quote";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_Quote" {...props} />,
	modules: ['Content_Quote'],
	moduleId: "Content_Quote",
});
	

const feature_Content_PageHeader = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_PageHeader" */
		'~/feature/Content/PageHeader').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_PageHeader";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_PageHeader" {...props} />,
	modules: ['Content_PageHeader'],
	moduleId: "Content_PageHeader",
});
	

const feature_Content_RichPageHeader = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_RichPageHeader" */
		'~/feature/Content/RichPageHeader').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_RichPageHeader";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_RichPageHeader" {...props} />,
	modules: ['Content_RichPageHeader'],
	moduleId: "Content_RichPageHeader",
});
	

const feature_Content_Accordion = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_Accordion" */
		'~/feature/Content/Accordion').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_Accordion";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_Accordion" {...props} />,
	modules: ['Content_Accordion'],
	moduleId: "Content_Accordion",
});
	

const feature_Content_RatingCarousel = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_RatingCarousel" */
		'~/feature/Content/RatingCarousel').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_RatingCarousel";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_RatingCarousel" {...props} />,
	modules: ['Content_RatingCarousel'],
	moduleId: "Content_RatingCarousel",
});
	

const feature_Content_Sitemap = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_Sitemap" */
		'~/feature/Content/Sitemap').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_Sitemap";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_Sitemap" {...props} />,
	modules: ['Content_Sitemap'],
	moduleId: "Content_Sitemap",
});
	

const feature_Content_InvestorRibbon = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_InvestorRibbon" */
		'~/feature/Content/InvestorRibbon').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_InvestorRibbon";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_InvestorRibbon" {...props} />,
	modules: ['Content_InvestorRibbon'],
	moduleId: "Content_InvestorRibbon",
});
	

const feature_Content_Timeline = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_Timeline" */
		'~/feature/Content/Timeline').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_Timeline";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_Timeline" {...props} />,
	modules: ['Content_Timeline'],
	moduleId: "Content_Timeline",
});
	

const feature_Content_KeyIRNumbers = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_KeyIRNumbers" */
		'~/feature/Content/KeyIRNumbers').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_KeyIRNumbers";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_KeyIRNumbers" {...props} />,
	modules: ['Content_KeyIRNumbers'],
	moduleId: "Content_KeyIRNumbers",
});
	

const feature_Content_CoverPageHeader = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_CoverPageHeader" */
		'~/feature/Content/CoverPageHeader').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_CoverPageHeader";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_CoverPageHeader" {...props} />,
	modules: ['Content_CoverPageHeader'],
	moduleId: "Content_CoverPageHeader",
});
	

const feature_Content_MultiColumnRichText = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_MultiColumnRichText" */
		'~/feature/Content/MultiColumnRichText').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_MultiColumnRichText";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_MultiColumnRichText" {...props} />,
	modules: ['Content_MultiColumnRichText'],
	moduleId: "Content_MultiColumnRichText",
});
	

const feature_Content_KeyFactsNumber = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_KeyFactsNumber" */
		'~/feature/Content/KeyFactsNumber').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_KeyFactsNumber";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_KeyFactsNumber" {...props} />,
	modules: ['Content_KeyFactsNumber'],
	moduleId: "Content_KeyFactsNumber",
});
	

const feature_Content_KeyFactsText = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_KeyFactsText" */
		'~/feature/Content/KeyFactsText').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_KeyFactsText";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_KeyFactsText" {...props} />,
	modules: ['Content_KeyFactsText'],
	moduleId: "Content_KeyFactsText",
});
	

const feature_Content_Table = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_Table" */
		'~/feature/Content/Table').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_Table";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_Table" {...props} />,
	modules: ['Content_Table'],
	moduleId: "Content_Table",
});
	

const feature_Content_IFrame = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_IFrame" */
		'~/feature/Content/IFrame').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_IFrame";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_IFrame" {...props} />,
	modules: ['Content_IFrame'],
	moduleId: "Content_IFrame",
});
	

const feature_Content_ImmersiveGarden = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_ImmersiveGarden" */
		'~/feature/Content/ImmersiveGarden').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_ImmersiveGarden";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_ImmersiveGarden" {...props} />,
	modules: ['Content_ImmersiveGarden'],
	moduleId: "Content_ImmersiveGarden",
});
	

const feature_Content_CookieNotice = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_CookieNotice" */
		'~/feature/Content/CookieNotice').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_CookieNotice";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_CookieNotice" {...props} />,
	modules: ['Content_CookieNotice'],
	moduleId: "Content_CookieNotice",
});
	

const feature_Content_BrandedQuote = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_BrandedQuote" */
		'~/feature/Content/BrandedQuote').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_BrandedQuote";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_BrandedQuote" {...props} />,
	modules: ['Content_BrandedQuote'],
	moduleId: "Content_BrandedQuote",
});
	

const feature_Content_Highlights = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_Highlights" */
		'~/feature/Content/Highlights').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_Highlights";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_Highlights" {...props} />,
	modules: ['Content_Highlights'],
	moduleId: "Content_Highlights",
});
	

const feature_Content_KeyNumbersList = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_KeyNumbersList" */
		'~/feature/Content/KeyNumbersList').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_KeyNumbersList";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_KeyNumbersList" {...props} />,
	modules: ['Content_KeyNumbersList'],
	moduleId: "Content_KeyNumbersList",
});
	

const feature_Content_KeyNumberHighlighted = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_KeyNumberHighlighted" */
		'~/feature/Content/KeyNumberHighlighted').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_KeyNumberHighlighted";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_KeyNumberHighlighted" {...props} />,
	modules: ['Content_KeyNumberHighlighted'],
	moduleId: "Content_KeyNumberHighlighted",
});
	

const feature_Content_PDFViewer = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_PDFViewer" */
		'~/feature/Content/PDFViewer').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_PDFViewer";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_PDFViewer" {...props} />,
	modules: ['Content_PDFViewer'],
	moduleId: "Content_PDFViewer",
});
	

const feature_Content_OperationalMap = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_OperationalMap" */
		'~/feature/Content/OperationalMap').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_OperationalMap";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_OperationalMap" {...props} />,
	modules: ['Content_OperationalMap'],
	moduleId: "Content_OperationalMap",
});
	

const feature_Content_KeyNumbersChart = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_KeyNumbersChart" */
		'~/feature/Content/KeyNumbersChart').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_KeyNumbersChart";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_KeyNumbersChart" {...props} />,
	modules: ['Content_KeyNumbersChart'],
	moduleId: "Content_KeyNumbersChart",
});
	

const feature_Content_AISummary = Loadable({
	loader: () => import(
		/* webpackChunkName: "Content_AISummary" */
		'~/feature/Content/AISummary').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Content_AISummary";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Content_AISummary" {...props} />,
	modules: ['Content_AISummary'],
	moduleId: "Content_AISummary",
});
	

const feature_Legacy_BodyContent = Loadable({
	loader: () => import(
		/* webpackChunkName: "Legacy_BodyContent" */
		'~/feature/Legacy/BodyContent').then(module => {
			const Component = module.BodyContent;
			(Component as any).displayName = "Legacy_BodyContent";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Legacy_BodyContent" {...props} />,
	modules: ['Legacy_BodyContent'],
	moduleId: "Legacy_BodyContent",
});
	

const feature_Legacy_News_C33NewsHeader = Loadable({
	loader: () => import(
		/* webpackChunkName: "Legacy_C33NewsHeader" */
		'~/feature/Legacy/News/C33NewsHeader').then(module => {
			const Component = module.C33NewsHeader;
			(Component as any).displayName = "Legacy_C33NewsHeader";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Legacy_C33NewsHeader" {...props} />,
	modules: ['Legacy_C33NewsHeader'],
	moduleId: "Legacy_C33NewsHeader",
});
	

const feature_Legacy_FullGridNoMargin = Loadable({
	loader: () => import(
		/* webpackChunkName: "Legacy_FullGridNoMargin" */
		'~/feature/Legacy/FullGridNoMargin').then(module => {
			const Component = module.FullGridNoMargin;
			(Component as any).displayName = "Legacy_FullGridNoMargin";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Legacy_FullGridNoMargin" {...props} />,
	modules: ['Legacy_FullGridNoMargin'],
	moduleId: "Legacy_FullGridNoMargin",
});
	

const feature_Legacy_NewsHeader = Loadable({
	loader: () => import(
		/* webpackChunkName: "Legacy_NewsHeader" */
		'~/feature/Legacy/NewsHeader').then(module => {
			const Component = module.NewsHeader;
			(Component as any).displayName = "Legacy_NewsHeader";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Legacy_NewsHeader" {...props} />,
	modules: ['Legacy_NewsHeader'],
	moduleId: "Legacy_NewsHeader",
});
	

const feature_Legacy_FullGrid = Loadable({
	loader: () => import(
		/* webpackChunkName: "Legacy_FullGrid" */
		'~/feature/Legacy/FullGrid').then(module => {
			const Component = module.FullGrid;
			(Component as any).displayName = "Legacy_FullGrid";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Legacy_FullGrid" {...props} />,
	modules: ['Legacy_FullGrid'],
	moduleId: "Legacy_FullGrid",
});
	

const feature_Legacy_News_C34RelatedTags = Loadable({
	loader: () => import(
		/* webpackChunkName: "Legacy_C34RelatedTags" */
		'~/feature/Legacy/News/C34RelatedTags').then(module => {
			const Component = module.C34RelatedTags;
			(Component as any).displayName = "Legacy_C34RelatedTags";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Legacy_C34RelatedTags" {...props} />,
	modules: ['Legacy_C34RelatedTags'],
	moduleId: "Legacy_C34RelatedTags",
});
	

const feature_Legacy_NewsFooter = Loadable({
	loader: () => import(
		/* webpackChunkName: "Legacy_NewsFooter" */
		'~/feature/Legacy/NewsFooter').then(module => {
			const Component = module.NewsFooter;
			(Component as any).displayName = "Legacy_NewsFooter";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Legacy_NewsFooter" {...props} />,
	modules: ['Legacy_NewsFooter'],
	moduleId: "Legacy_NewsFooter",
});
	

const feature_Legacy_News_C28RelatedArticles = Loadable({
	loader: () => import(
		/* webpackChunkName: "Legacy_C28RelatedArticles" */
		'~/feature/Legacy/News/C28RelatedArticles').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Legacy_C28RelatedArticles";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Legacy_C28RelatedArticles" {...props} />,
	modules: ['Legacy_C28RelatedArticles'],
	moduleId: "Legacy_C28RelatedArticles",
});
	

const feature_Legacy_BodySideModuleReversed = Loadable({
	loader: () => import(
		/* webpackChunkName: "Legacy_BodySideModuleReversed" */
		'~/feature/Legacy/BodySideModuleReversed').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Legacy_BodySideModuleReversed";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Legacy_BodySideModuleReversed" {...props} />,
	modules: ['Legacy_BodySideModuleReversed'],
	moduleId: "Legacy_BodySideModuleReversed",
});
	

const feature_Legacy_BodySideModule = Loadable({
	loader: () => import(
		/* webpackChunkName: "Legacy_BodySideModule" */
		'~/feature/Legacy/BodySideModule').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Legacy_BodySideModule";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Legacy_BodySideModule" {...props} />,
	modules: ['Legacy_BodySideModule'],
	moduleId: "Legacy_BodySideModule",
});
	

const feature_Legacy_MediaLayout = Loadable({
	loader: () => import(
		/* webpackChunkName: "Legacy_MediaLayout" */
		'~/feature/Legacy/MediaLayout').then(module => {
			const Component = module.MediaLayout;
			(Component as any).displayName = "Legacy_MediaLayout";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Legacy_MediaLayout" {...props} />,
	modules: ['Legacy_MediaLayout'],
	moduleId: "Legacy_MediaLayout",
});
	

const feature_Maps_InteractiveMap = Loadable({
	loader: () => import(
		/* webpackChunkName: "Maps_InteractiveMap" */
		'~/feature/Maps/InteractiveMap').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Maps_InteractiveMap";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Maps_InteractiveMap" {...props} />,
	modules: ['Maps_InteractiveMap'],
	moduleId: "Maps_InteractiveMap",
});
	

const feature_Maps_GoogleMap = Loadable({
	loader: () => import(
		/* webpackChunkName: "Maps_GoogleMap" */
		'~/feature/Maps/GoogleMap').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Maps_GoogleMap";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Maps_GoogleMap" {...props} />,
	modules: ['Maps_GoogleMap'],
	moduleId: "Maps_GoogleMap",
});
	

const feature_Media_HeroCarousel = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_HeroCarousel" */
		'~/feature/Media/HeroCarousel').then(module => {
			const Component = module.HeroCarousel;
			(Component as any).displayName = "Media_HeroCarousel";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_HeroCarousel" {...props} />,
	modules: ['Media_HeroCarousel'],
	moduleId: "Media_HeroCarousel",
});
	

const feature_Media_ImageCarousel = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_ImageCarousel" */
		'~/feature/Media/ImageCarousel').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_ImageCarousel";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_ImageCarousel" {...props} />,
	modules: ['Media_ImageCarousel'],
	moduleId: "Media_ImageCarousel",
});
	

const feature_Media_Image = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_Image" */
		'~/feature/Media/Image').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_Image";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_Image" {...props} />,
	modules: ['Media_Image'],
	moduleId: "Media_Image",
});
	

const feature_Media_Teaser = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_Teaser" */
		'~/feature/Media/Teaser').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_Teaser";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_Teaser" {...props} />,
	modules: ['Media_Teaser'],
	moduleId: "Media_Teaser",
});
	

const feature_Media_LargeTeaser = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_LargeTeaser" */
		'~/feature/Media/LargeTeaser').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_LargeTeaser";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_LargeTeaser" {...props} />,
	modules: ['Media_LargeTeaser'],
	moduleId: "Media_LargeTeaser",
});
	

const feature_Media_MegaTeaser = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_MegaTeaser" */
		'~/feature/Media/MegaTeaser').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_MegaTeaser";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_MegaTeaser" {...props} />,
	modules: ['Media_MegaTeaser'],
	moduleId: "Media_MegaTeaser",
});
	

const feature_Media_Video = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_Video" */
		'~/feature/Media/Video').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_Video";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_Video" {...props} />,
	modules: ['Media_Video'],
	moduleId: "Media_Video",
});
	

const feature_Media_CardContainer = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_CardContainer" */
		'~/feature/Media/CardContainer').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_CardContainer";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_CardContainer" {...props} />,
	modules: ['Media_CardContainer'],
	moduleId: "Media_CardContainer",
});
	

(feature_Media_Card as any).displayName = "Media_Card";


const feature_Media_SplitTeaser = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_SplitTeaser" */
		'~/feature/Media/SplitTeaser').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_SplitTeaser";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_SplitTeaser" {...props} />,
	modules: ['Media_SplitTeaser'],
	moduleId: "Media_SplitTeaser",
});
	

const feature_Media_InternalScroll = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_InternalScroll" */
		'~/feature/Media/InternalScroll').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_InternalScroll";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_InternalScroll" {...props} />,
	modules: ['Media_InternalScroll'],
	moduleId: "Media_InternalScroll",
});
	

const feature_Media_DocumentList = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_DocumentList" */
		'~/feature/Media/DocumentList').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_DocumentList";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_DocumentList" {...props} />,
	modules: ['Media_DocumentList'],
	moduleId: "Media_DocumentList",
});
	

const feature_Media_MultiColumnPromo = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_MultiColumnPromo" */
		'~/feature/Media/MultiColumnPromo').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_MultiColumnPromo";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_MultiColumnPromo" {...props} />,
	modules: ['Media_MultiColumnPromo'],
	moduleId: "Media_MultiColumnPromo",
});
	

const feature_Media_ImageQuote = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_ImageQuote" */
		'~/feature/Media/ImageQuote').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_ImageQuote";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_ImageQuote" {...props} />,
	modules: ['Media_ImageQuote'],
	moduleId: "Media_ImageQuote",
});
	

const feature_Media_CareersWidget = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_CareersWidget" */
		'~/feature/Media/CareersWidget').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_CareersWidget";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_CareersWidget" {...props} />,
	modules: ['Media_CareersWidget'],
	moduleId: "Media_CareersWidget",
});
	

const feature_Media_QuotesOnARowContainer = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_QuotesOnARowContainer" */
		'~/feature/Media/QuotesOnARowContainer').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_QuotesOnARowContainer";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_QuotesOnARowContainer" {...props} />,
	modules: ['Media_QuotesOnARowContainer'],
	moduleId: "Media_QuotesOnARowContainer",
});
	

const feature_Media_QuotesOnARow = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_QuotesOnARow" */
		'~/feature/Media/QuotesOnARow').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_QuotesOnARow";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_QuotesOnARow" {...props} />,
	modules: ['Media_QuotesOnARow'],
	moduleId: "Media_QuotesOnARow",
});
	

const feature_Media_MicroCards = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_MicroCards" */
		'~/feature/Media/MicroCards').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_MicroCards";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_MicroCards" {...props} />,
	modules: ['Media_MicroCards'],
	moduleId: "Media_MicroCards",
});
	

const feature_Media_Hero = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_Hero" */
		'~/feature/Media/Hero').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_Hero";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_Hero" {...props} />,
	modules: ['Media_Hero'],
	moduleId: "Media_Hero",
});
	

const feature_Media_DocumentListTwoColumn = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_DocumentListTwoColumn" */
		'~/feature/Media/DocumentListTwoColumn').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_DocumentListTwoColumn";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_DocumentListTwoColumn" {...props} />,
	modules: ['Media_DocumentListTwoColumn'],
	moduleId: "Media_DocumentListTwoColumn",
});
	

const feature_Media_ScrollStory = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_ScrollStory" */
		'~/feature/Media/ScrollStory').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_ScrollStory";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_ScrollStory" {...props} />,
	modules: ['Media_ScrollStory'],
	moduleId: "Media_ScrollStory",
});
	

const feature_Media_ReportPageHero = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_ReportPageHero" */
		'~/feature/Media/ReportPageHero').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_ReportPageHero";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_ReportPageHero" {...props} />,
	modules: ['Media_ReportPageHero'],
	moduleId: "Media_ReportPageHero",
});
	

const feature_Media_ChapterTeaserQuote = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_ChapterTeaserQuote" */
		'~/feature/Media/ChapterTeaserQuote').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_ChapterTeaserQuote";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_ChapterTeaserQuote" {...props} />,
	modules: ['Media_ChapterTeaserQuote'],
	moduleId: "Media_ChapterTeaserQuote",
});
	

const feature_Media_ChapterTeaser = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_ChapterTeaser" */
		'~/feature/Media/ChapterTeaser').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_ChapterTeaser";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_ChapterTeaser" {...props} />,
	modules: ['Media_ChapterTeaser'],
	moduleId: "Media_ChapterTeaser",
});
	

(feature_Media_ScriptAsset as any).displayName = "Media_ScriptAsset";


const feature_Media_DocumentListGrid = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_DocumentListGrid" */
		'~/feature/Media/DocumentListGrid').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_DocumentListGrid";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_DocumentListGrid" {...props} />,
	modules: ['Media_DocumentListGrid'],
	moduleId: "Media_DocumentListGrid",
});
	

const feature_Media_BusinessModel = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_BusinessModel" */
		'~/feature/Media/BusinessModel').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_BusinessModel";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_BusinessModel" {...props} />,
	modules: ['Media_BusinessModel'],
	moduleId: "Media_BusinessModel",
});
	

const feature_Media_SocialWallSlider = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_SocialWallSlider" */
		'~/feature/Media/SocialWallSlider').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_SocialWallSlider";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_SocialWallSlider" {...props} />,
	modules: ['Media_SocialWallSlider'],
	moduleId: "Media_SocialWallSlider",
});
	

const feature_Media_VideoGallery = Loadable({
	loader: () => import(
		/* webpackChunkName: "Media_VideoGallery" */
		'~/feature/Media/VideoGallery').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Media_VideoGallery";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Media_VideoGallery" {...props} />,
	modules: ['Media_VideoGallery'],
	moduleId: "Media_VideoGallery",
});
	

(feature_Navigation_MainNavigation as any).displayName = "Navigation_MainNavigation";


(feature_Navigation_HygieneNavigation as any).displayName = "Navigation_HygieneNavigation";


const feature_Navigation_FooterNavigation = Loadable({
	loader: () => import(
		/* webpackChunkName: "Navigation_FooterNavigation" */
		'~/feature/Navigation/FooterNavigation').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Navigation_FooterNavigation";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Navigation_FooterNavigation" {...props} />,
	modules: ['Navigation_FooterNavigation'],
	moduleId: "Navigation_FooterNavigation",
});
	

(feature_Navigation_BreadcrumbNavigation as any).displayName = "Navigation_BreadcrumbNavigation";


const feature_Navigation_GlobalContactsNavigation = Loadable({
	loader: () => import(
		/* webpackChunkName: "Navigation_GlobalContactsNavigation" */
		'~/feature/Navigation/GlobalContactsNavigation').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Navigation_GlobalContactsNavigation";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Navigation_GlobalContactsNavigation" {...props} />,
	modules: ['Navigation_GlobalContactsNavigation'],
	moduleId: "Navigation_GlobalContactsNavigation",
});
	

const feature_Navigation_ChapterNavigation = Loadable({
	loader: () => import(
		/* webpackChunkName: "Navigation_ChapterNavigation" */
		'~/feature/Navigation/ChapterNavigation').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Navigation_ChapterNavigation";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Navigation_ChapterNavigation" {...props} />,
	modules: ['Navigation_ChapterNavigation'],
	moduleId: "Navigation_ChapterNavigation",
});
	

const feature_Navigation_Chapter = Loadable({
	loader: () => import(
		/* webpackChunkName: "Navigation_Chapter" */
		'~/feature/Navigation/Chapter').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Navigation_Chapter";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Navigation_Chapter" {...props} />,
	modules: ['Navigation_Chapter'],
	moduleId: "Navigation_Chapter",
});
	

const feature_Navigation_SubpageNavigation = Loadable({
	loader: () => import(
		/* webpackChunkName: "Navigation_SubpageNavigation" */
		'~/feature/Navigation/SubpageNavigation').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Navigation_SubpageNavigation";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Navigation_SubpageNavigation" {...props} />,
	modules: ['Navigation_SubpageNavigation'],
	moduleId: "Navigation_SubpageNavigation",
});
	

const feature_Search_SearchFilter = Loadable({
	loader: () => import(
		/* webpackChunkName: "Search_SearchFilter" */
		'~/feature/Search/SearchFilter').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Search_SearchFilter";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Search_SearchFilter" {...props} />,
	modules: ['Search_SearchFilter'],
	moduleId: "Search_SearchFilter",
});
	

const feature_Search_SearchResultsMediaGallery = Loadable({
	loader: () => import(
		/* webpackChunkName: "Search_SearchResultsMediaGallery" */
		'~/feature/Search/SearchResultsMediaGallery').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Search_SearchResultsMediaGallery";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Search_SearchResultsMediaGallery" {...props} />,
	modules: ['Search_SearchResultsMediaGallery'],
	moduleId: "Search_SearchResultsMediaGallery",
});
	

const feature_Search_SearchResultsPublication = Loadable({
	loader: () => import(
		/* webpackChunkName: "Search_SearchResultsPublication" */
		'~/feature/Search/SearchResultsPublication').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Search_SearchResultsPublication";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Search_SearchResultsPublication" {...props} />,
	modules: ['Search_SearchResultsPublication'],
	moduleId: "Search_SearchResultsPublication",
});
	

const feature_Search_SearchResultsArticle = Loadable({
	loader: () => import(
		/* webpackChunkName: "Search_SearchResultsArticle" */
		'~/feature/Search/SearchResultsArticle').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Search_SearchResultsArticle";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Search_SearchResultsArticle" {...props} />,
	modules: ['Search_SearchResultsArticle'],
	moduleId: "Search_SearchResultsArticle",
});
	

const feature_Search_SearchResults = Loadable({
	loader: () => import(
		/* webpackChunkName: "Search_SearchResults" */
		'~/feature/Search/SearchResults').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Search_SearchResults";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Search_SearchResults" {...props} />,
	modules: ['Search_SearchResults'],
	moduleId: "Search_SearchResults",
});
	

const feature_Search_RelatedTags = Loadable({
	loader: () => import(
		/* webpackChunkName: "Search_RelatedTags" */
		'~/feature/Search/RelatedTags').then(module => {
			const Component = module.default;
			(Component as any).displayName = "Search_RelatedTags";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="Search_RelatedTags" {...props} />,
	modules: ['Search_RelatedTags'],
	moduleId: "Search_RelatedTags",
});
	

const project_AramcoCom_Header = Loadable({
	loader: () => import(
		/* webpackChunkName: "AramcoCom_Header" */
		'~/project/AramcoCom/Header').then(module => {
			const Component = module.default;
			(Component as any).displayName = "AramcoCom_Header";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="AramcoCom_Header" {...props} />,
	modules: ['AramcoCom_Header'],
	moduleId: "AramcoCom_Header",
});
	

(project_AramcoCom_Footer as any).displayName = "AramcoCom_Footer";


const project_AramcoCom_OneColumn = Loadable({
	loader: () => import(
		/* webpackChunkName: "AramcoCom_OneColumn" */
		'~/project/AramcoCom/OneColumn').then(module => {
			const Component = module.default;
			(Component as any).displayName = "AramcoCom_OneColumn";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="AramcoCom_OneColumn" {...props} />,
	modules: ['AramcoCom_OneColumn'],
	moduleId: "AramcoCom_OneColumn",
});
	

const project_AramcoCom_TwoColumn = Loadable({
	loader: () => import(
		/* webpackChunkName: "AramcoCom_TwoColumn" */
		'~/project/AramcoCom/TwoColumn').then(module => {
			const Component = module.default;
			(Component as any).displayName = "AramcoCom_TwoColumn";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="AramcoCom_TwoColumn" {...props} />,
	modules: ['AramcoCom_TwoColumn'],
	moduleId: "AramcoCom_TwoColumn",
});
	

const project_AramcoCom_Form = Loadable({
	loader: () => import(
		/* webpackChunkName: "AramcoCom_Form" */
		'~/project/AramcoCom/Form').then(module => {
			const Component = module.default;
			(Component as any).displayName = "AramcoCom_Form";
			return lazyHydrate(Component);
		}),
	loading: (props: { error?: Error | unknown, retry?: () => void }) => <ComponentLoader componentName="AramcoCom_Form" {...props} />,
	modules: ['AramcoCom_Form'],
	moduleId: "AramcoCom_Form",
});
	
components.set("feature/Article/ArticleHeader", feature_Article_ArticleHeader);
components.set("feature/Article/LatestArticlesCardList", feature_Article_LatestArticlesCardList);
components.set("feature/Article/MagazineArticleHeader", feature_Article_MagazineArticleHeader);
components.set("feature/Article/AllArticlesCardList", feature_Article_AllArticlesCardList);
components.set("feature/Article/LatestFeaturedArticle", feature_Article_LatestFeaturedArticle);
components.set("feature/Content/RichText", feature_Content_RichText);
components.set("feature/Content/Quote", feature_Content_Quote);
components.set("feature/Content/PageHeader", feature_Content_PageHeader);
components.set("feature/Content/RichPageHeader", feature_Content_RichPageHeader);
components.set("feature/Content/Accordion", feature_Content_Accordion);
components.set("feature/Content/RatingCarousel", feature_Content_RatingCarousel);
components.set("feature/Content/Sitemap", feature_Content_Sitemap);
components.set("feature/Content/InvestorRibbon", feature_Content_InvestorRibbon);
components.set("feature/Content/Timeline", feature_Content_Timeline);
components.set("feature/Content/KeyIRNumbers", feature_Content_KeyIRNumbers);
components.set("feature/Content/CoverPageHeader", feature_Content_CoverPageHeader);
components.set("feature/Content/MultiColumnRichText", feature_Content_MultiColumnRichText);
components.set("feature/Content/KeyFactsNumber", feature_Content_KeyFactsNumber);
components.set("feature/Content/KeyFactsText", feature_Content_KeyFactsText);
components.set("feature/Content/Table", feature_Content_Table);
components.set("feature/Content/IFrame", feature_Content_IFrame);
components.set("feature/Content/ImmersiveGarden", feature_Content_ImmersiveGarden);
components.set("feature/Content/CookieNotice", feature_Content_CookieNotice);
components.set("feature/Content/BrandedQuote", feature_Content_BrandedQuote);
components.set("feature/Content/Highlights", feature_Content_Highlights);
components.set("feature/Content/KeyNumbersList", feature_Content_KeyNumbersList);
components.set("feature/Content/KeyNumberHighlighted", feature_Content_KeyNumberHighlighted);
components.set("feature/Content/PDFViewer", feature_Content_PDFViewer);
components.set("feature/Content/OperationalMap", feature_Content_OperationalMap);
components.set("feature/Content/KeyNumbersChart", feature_Content_KeyNumbersChart);
components.set("feature/Content/AISummary", feature_Content_AISummary);
components.set("feature/Legacy/BodyContent", feature_Legacy_BodyContent);
components.set("feature/Legacy/News/C33NewsHeader", feature_Legacy_News_C33NewsHeader);
components.set("feature/Legacy/FullGridNoMargin", feature_Legacy_FullGridNoMargin);
components.set("feature/Legacy/NewsHeader", feature_Legacy_NewsHeader);
components.set("feature/Legacy/FullGrid", feature_Legacy_FullGrid);
components.set("feature/Legacy/News/C34RelatedTags", feature_Legacy_News_C34RelatedTags);
components.set("feature/Legacy/NewsFooter", feature_Legacy_NewsFooter);
components.set("feature/Legacy/News/C28RelatedArticles", feature_Legacy_News_C28RelatedArticles);
components.set("feature/Legacy/BodySideModuleReversed", feature_Legacy_BodySideModuleReversed);
components.set("feature/Legacy/BodySideModule", feature_Legacy_BodySideModule);
components.set("feature/Legacy/MediaLayout", feature_Legacy_MediaLayout);
components.set("feature/Maps/InteractiveMap", feature_Maps_InteractiveMap);
components.set("feature/Maps/GoogleMap", feature_Maps_GoogleMap);
components.set("feature/Media/HeroCarousel", feature_Media_HeroCarousel);
components.set("feature/Media/ImageCarousel", feature_Media_ImageCarousel);
components.set("feature/Media/Image", feature_Media_Image);
components.set("feature/Media/Teaser", feature_Media_Teaser);
components.set("feature/Media/LargeTeaser", feature_Media_LargeTeaser);
components.set("feature/Media/MegaTeaser", feature_Media_MegaTeaser);
components.set("feature/Media/Video", feature_Media_Video);
components.set("feature/Media/CardContainer", feature_Media_CardContainer);
components.set("feature/Media/Card", lazyHydrate(feature_Media_Card));
components.set("feature/Media/SplitTeaser", feature_Media_SplitTeaser);
components.set("feature/Media/InternalScroll", feature_Media_InternalScroll);
components.set("feature/Media/DocumentList", feature_Media_DocumentList);
components.set("feature/Media/MultiColumnPromo", feature_Media_MultiColumnPromo);
components.set("feature/Media/ImageQuote", feature_Media_ImageQuote);
components.set("feature/Media/CareersWidget", feature_Media_CareersWidget);
components.set("feature/Media/QuotesOnARowContainer", feature_Media_QuotesOnARowContainer);
components.set("feature/Media/QuotesOnARow", feature_Media_QuotesOnARow);
components.set("feature/Media/MicroCards", feature_Media_MicroCards);
components.set("feature/Media/Hero", feature_Media_Hero);
components.set("feature/Media/DocumentListTwoColumn", feature_Media_DocumentListTwoColumn);
components.set("feature/Media/ScrollStory", feature_Media_ScrollStory);
components.set("feature/Media/ReportPageHero", feature_Media_ReportPageHero);
components.set("feature/Media/ChapterTeaserQuote", feature_Media_ChapterTeaserQuote);
components.set("feature/Media/ChapterTeaser", feature_Media_ChapterTeaser);
components.set("feature/Media/ScriptAsset", lazyHydrate(feature_Media_ScriptAsset));
components.set("feature/Media/DocumentListGrid", feature_Media_DocumentListGrid);
components.set("feature/Media/BusinessModel", feature_Media_BusinessModel);
components.set("feature/Media/SocialWallSlider", feature_Media_SocialWallSlider);
components.set("feature/Media/VideoGallery", feature_Media_VideoGallery);
components.set("feature/Navigation/MainNavigation", lazyHydrate(feature_Navigation_MainNavigation));
components.set("feature/Navigation/HygieneNavigation", lazyHydrate(feature_Navigation_HygieneNavigation));
components.set("feature/Navigation/FooterNavigation", feature_Navigation_FooterNavigation);
components.set("feature/Navigation/BreadcrumbNavigation", lazyHydrate(feature_Navigation_BreadcrumbNavigation));
components.set("feature/Navigation/GlobalContactsNavigation", feature_Navigation_GlobalContactsNavigation);
components.set("feature/Navigation/ChapterNavigation", feature_Navigation_ChapterNavigation);
components.set("feature/Navigation/Chapter", feature_Navigation_Chapter);
components.set("feature/Navigation/SubpageNavigation", feature_Navigation_SubpageNavigation);
components.set("feature/Search/SearchFilter", feature_Search_SearchFilter);
components.set("feature/Search/SearchResultsMediaGallery", feature_Search_SearchResultsMediaGallery);
components.set("feature/Search/SearchResultsPublication", feature_Search_SearchResultsPublication);
components.set("feature/Search/SearchResultsArticle", feature_Search_SearchResultsArticle);
components.set("feature/Search/SearchResults", feature_Search_SearchResults);
components.set("feature/Search/RelatedTags", feature_Search_RelatedTags);
components.set("project/AramcoCom/Header", project_AramcoCom_Header);
components.set("project/AramcoCom/Footer", lazyHydrate(project_AramcoCom_Footer));
components.set("project/AramcoCom/OneColumn", project_AramcoCom_OneColumn);
components.set("project/AramcoCom/TwoColumn", project_AramcoCom_TwoColumn);
components.set("project/AramcoCom/Form", project_AramcoCom_Form);

export default function componentFactory(componentName: string) {
  return components.get(componentName);
}
